import { useState, useCallback } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useGetClientBySearch = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProviderBySearchTerm = useCallback(async (queryParams = {}) => {
    if (!queryParams || Object.keys(queryParams).length === 0) return;

    setLoading(true);

    try {
      const response = await api_without_cancellation.post("/api/search/clients/", {
        ...queryParams,
      });
      setData(response.data);
      setError(null);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, fetchProviderBySearchTerm };
};

export default useGetClientBySearch;
